import React, { Component } from 'react';
import FlipMove from 'react-flip-move';
import { CSSTransition } from 'react-transition-group';

import cardsData from '../cards.json';

import './progress-bar.scss';

export default class ProgressBar extends Component {
    items = cardsData.map((_, idx) => {
        return (
            <div
                className={`progress-bar-item ${idx === 0 ? 'active' : ''}`}
                key={idx}
            />
        )
    });
    active = 0;

    render() {
        const currentId = this.props.cardId;
        if (this.active + 1 !== currentId) {
            this.items.splice(currentId - 1, 0, ...this.items.splice(this.active, 1));
            this.active = currentId - 1;
        }

        return (
            <React.Fragment>
                <CSSTransition
                    in={this.props.isGameStarted}
                    timeout={2000}
                    classNames='deck'
                    appear
                >
                    <FlipMove className="progress-bar-block">
                        {[...this.items]}
                    </ FlipMove>
                </CSSTransition>
            </React.Fragment>
        )
    }
}
